import React from 'react';
import Button from '../ui/Button';
import { cn } from '@/lib/utils';
import { SearchTypes } from './SearchLayoutCommon';
import { DeliveryMini, Pickup } from '@ui/Icons';
import { useTranslations } from 'next-intl';
import { STOREFRONT } from '@/lib/utils/translation';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';

type Props = {
  shippingType: SearchTypes;
  changeDeliveryType: (type: SearchTypes) => void;
};

export default function SearchOptionButtons({
  shippingType,
  changeDeliveryType,
}: Props) {
  const t = useTranslations();
  return (
    <div className="inline-flex items-center rounded-full bg-[#ECECEC]">
      <Button
        className={cn(
          `flex items-center rounded-full bg-transparent px-[25px] py-[13px] font-normal text-black`,
          shippingType === 'all' && 'bg-primary-700 text-white'
        )}
        onClick={() => changeDeliveryType('all')}
      >
        <BuildingStorefrontIcon className="h-5 w-5" />
        <span className="ml-[8px] hidden lg:block">
          {t(`${STOREFRONT.SEARCH}.all`)}
        </span>
      </Button>
      <Button
        className={cn(
          `flex items-center rounded-full bg-transparent px-[25px] py-[13px] font-normal text-black`,
          shippingType === 'delivery' && 'bg-primary-700 text-white'
        )}
        onClick={() => changeDeliveryType('delivery')}
      >
        <DeliveryMini />
        <span className="ml-[8px] hidden lg:block">
          {t(`${STOREFRONT.SEARCH}.delivery`)}
        </span>
      </Button>
      <Button
        onClick={() => changeDeliveryType('pickup')}
        className={cn(
          `flex items-center rounded-full bg-transparent px-[25px] py-[13px] font-normal text-black`,
          shippingType === 'pickup' && 'bg-primary-700 text-white'
        )}
      >
        <Pickup />
        <span className="ml-[8px] hidden lg:block">
          {t(`${STOREFRONT.SEARCH}.pickup`)}
        </span>
      </Button>
    </div>
  );
}
